/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pay_Link_TitleInputs */

const en_pay_link_title = /** @type {(inputs: Pay_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const pl_pay_link_title = /** @type {(inputs: Pay_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Pay_Link_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pay_link_title = /** @type {((inputs?: Pay_Link_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pay_Link_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pay_link_title(inputs)
	return en_pay_link_title(inputs)
});